import { Alert, AlertDescription } from "../../../ui/common/alert";
import { cn } from "../../../../lib/utils";

interface VersionHistoryStateMessageProps {
  tone: "info" | "warning" | "error";
  message: string;
  testId?: string;
}

const TONE_CLASSNAME: Record<VersionHistoryStateMessageProps["tone"], string> = {
  info: "tw-border-border tw-bg-secondary/30 tw-text-muted-foreground [&>svg]:tw-hidden",
  warning: "tw-border-warning/30 tw-bg-warning/10 tw-text-warning [&>svg]:tw-hidden",
  error: "tw-border-destructive/50 tw-bg-destructive/10 tw-text-destructive [&>svg]:tw-hidden"
};

export const VersionHistoryStateMessage = ({ tone, message, testId }: VersionHistoryStateMessageProps) => (
  <Alert data-testid={testId} className={cn("tw-py-2", TONE_CLASSNAME[tone])}>
    <AlertDescription className="tw-text-sm">{message}</AlertDescription>
  </Alert>
);
